import { PollProps } from './types';

export const Poll = ({ children }: PollProps) => <div className="w-full max-w-6xl flex mb-4">{children}</div>;
